<template>
  <div 
    data-app
    id="app"
    v-scroll="onScroll">
    <!-- Start Navbar -->
    <core-navbar/>
    <!-- End Navbar -->
    <!-- start dialog for reservations -->
    <core-reserve />
    <!-- end dialog for reservations -->
    <!-- start main router view -->
    <router-view/>
    <!-- end main router view -->
    <!-- start footer -->
    <core-footer/>
    <!-- end footer -->
    <core-whatsapp 
      :phone_number="phoneNumber"
    />
    <!-- Start alert component -->
    <transition
      name="global_alert">
      <v-alert 
        style="min-width: 360px; max-width: 360px"
        v-show="bShowAlert"
        :class="sAlertType == 'success' ? 'app-global-alert color_success':'app-global-alert color_error'"
        :type="sAlertType">
        <p
          class="app-alert-text">
          {{sAlertText}}
        </p>
      </v-alert>
    </transition>
    <!-- End alert component -->
  </div>
</template>
<script>
export default {
  /**
   * Alert method example:
   * toggles active alert
    setAlert () {
      this.$store.commit('toggleAlert', {
        sText: 'Favor de ingresar un estatus correcto.',
        sAlertType: 'success' // error , success
      })
    }
  */
  watch: {
    // control active alert state
    bShowAlert: function () {
      if ( this.bShowAlert ) {
        const self = this
        // set timeout to automatically close alert
        setTimeout( function () { 
          self.$store.commit('setAlertState', false)
        }, 5000)
      }
    }
  },
  computed: {
    // alert computed variables for reactive alert
    sAlertText () {
      return this.$store.state.sText
    },
    sAlertType () {
      return this.$store.state.sAlertType
    },
    bShowAlert () {
      return this.$store.state.bAlert
    },
  },
  data: () => ({
    phoneNumber: '8182532592',
  }),
  components: {
    CoreNavbar: () => import('@/components/core/Navbar.vue'),
    CoreReserve: () => import('@/components/core/Reserve.vue'),
    CoreFooter: () => import('@/components/core/Footer.vue'),
    CoreWhatsapp: () => import('@/components/core/Whatsapp')
  },
  methods: {
    setAlert () {
      this.$store.commit('toggleAlert', {
        sText: 'Favor de ingresar un estatus correcto.',
        sAlertType: 'success' // error , success
      })
    },
    // modify global offsetTop
    onScroll(e) {
      this.$store.commit(
        "setOffsetTop",
        window.pageYOffset || document.documentElement.scrollTop
      )
    },
  }
}
</script>
<style>
body {
  overflow-y: hidden;    
}

body ::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge add Firefox */
body {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.flex-centered {
  display: flex; 
  justify-content: center
}
.section-title {
  align-self: center;
  text-align: center;
  color: #5C5C5C;
  font-weight: 700;
  font-size: 32px;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 30px;
  text-transform: uppercase
}
.section-spacing {
  padding-bottom: 60px
}
/* Styles alert */
  .color_error {
    background-color: red !important;
  }
  .color_success {
    background-color: green !important;
  }
  .app-alert-text {
    padding-left: 10px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    color: white !important;
    font-weight: bold
  }
  .app-global-alert {
    position: fixed !important;
    top: 20px !important;
    right: 20px !important;
    width: 30vw;
    z-index: 1000
  }
  .global_alert-enter,
  .global_alert-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }
  .global_alert-enter-active {
    transition: all .3s ease;
  }
  .global_alert-leave-active {
    transition: all .3s ease;
  }
</style>
